import React, { createContext, useContext, useState } from 'react';
import { Product, Order } from './HVAProductAndOrdersData';

interface ClientInfo {
  customerId: string;
  email: string;
  name: string;
}

interface HVAConversationContextType {
  clientInfo: ClientInfo | null;
  setClientInfo: (info: ClientInfo) => void;
  isCustomerIdValidated: boolean;
  setIsCustomerIdValidated: (validated: boolean) => void;
  isEmailValidated: boolean;
  setIsEmailValidated: (validated: boolean) => void;
  products: Product[];
  setProducts: (products: Product[]) => void;
  orders: Order[];
  setOrders: (orders: Order[]) => void;
  requestTransfer: boolean;
  setRequestTransfer: (transfer: boolean) => void;
}

const HVAConversationContext = createContext<
  HVAConversationContextType | undefined
>(undefined);

export const HVAConversationProvider: React.FC<{
  children: React.ReactNode;
}> = ({ children }) => {
  const [clientInfo, setClientInfo] = useState<ClientInfo | null>(null);
  const [isCustomerIdValidated, setIsCustomerIdValidated] = useState(false);
  const [isEmailValidated, setIsEmailValidated] = useState(false);
  const [products, setProducts] = useState<Product[]>([]);
  const [orders, setOrders] = useState<Order[]>([]);
  const [requestTransfer, setRequestTransfer] = useState(false);

  const value = {
    clientInfo,
    setClientInfo,
    isCustomerIdValidated,
    setIsCustomerIdValidated,
    isEmailValidated,
    setIsEmailValidated,
    products,
    setProducts,
    orders,
    setOrders,
    requestTransfer,
    setRequestTransfer
  };

  return (
    <HVAConversationContext.Provider value={value}>
      {children}
    </HVAConversationContext.Provider>
  );
};

export const useHVAConversation = () => {
  const context = useContext(HVAConversationContext);
  if (context === undefined) {
    throw new Error(
      'useHVAConversation must be used within a HVAConversationProvider'
    );
  }
  return context;
};
